// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-maintenance-plan';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import OpenMaintenancePlan, {getDefaultState as getOpenMaintenancePlanDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import OpenMaintenancePlans, {getDefaultState as getOpenMaintenancePlansDefaultState} from './open-maintenance-plans';
import OpenServiceIntervals, {getDefaultState as getOpenServiceIntervalsDefaultState} from './open-service-intervals';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../../../src/claim/shared/state/warranty-status-modal';
import t from 'tcomb';

const MaintenancePlanClaim = t.struct({
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    formValidation: FormValidation,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    openMaintenancePlans: OpenMaintenancePlans,
    openServiceIntervals: OpenServiceIntervals,
    product: Product,
    selectedOpenMaintenancePlan: OpenMaintenancePlan,
    showNoResultsFound: t.Boolean,
    temporaryObjectKey: t.String,
    warrantyStatusModal: WarrantyStatusModal

}, 'MaintenancePlanClaim');

export const getDefaultState = () =>
    new MaintenancePlanClaim({
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        customer: getCustomerDefaultState(),
        formValidation: getDefaultFormValidationState(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isStickyHeaderVisible: false,
        openMaintenancePlans: getOpenMaintenancePlansDefaultState(),
        openServiceIntervals: getOpenServiceIntervalsDefaultState(),
        product: getProductDefaultState(),
        selectedOpenMaintenancePlan: getOpenMaintenancePlanDefaultState(),
        showNoResultsFound: false,
        temporaryObjectKey: '',
        warrantyStatusModal: getWarrantyStatusModal()
    });

export default MaintenancePlanClaim;



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/state/index.js